import Extensions from '../../extensions';
import Navigator from "../../global/navigator";
import Header from "../../global/header";
import Footer from "../../global/footer";
import FormController from "./form-controller";
import sendCookieNotification from './cookie-notifier';
import initSeoStuff from './seo-stuff';

// import WidgetGiftCertificate from "./widgets/widget-gift-certificate";

import DOMHelper from "../../lib/dom-helper";
import ServiceLocator from "../../global/service-locator";
import LangSwitcher from "../../global/lang-switcher";
import SpecialEventQuiz from "../../components/special-event/special-event-quiz";
import SpecialEventPopup from "../../components/special-event/special-event-popup";
import Gift2024 from "../../components/gift2024";

export default class CoreModule {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.navigator = new Navigator();
		this.extensions = new Extensions();
		this.header = new Header();
		this.footer = new Footer();
		this.formController = new FormController();

		sendCookieNotification();
		initSeoStuff();

		this.initTooltips();
		// this.initWidgetGiftCertificate();
		this.initLangSwitcher();
		this.initSpecialEvent();
	}

	initTooltips() {
		DOMHelper.tooltips();
	}

	// initWidgetGiftCertificate() {
	// 	if (craft.env.dynamicHeader) {
	// 		this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
	// 			this.widgetGiftCertificate = new WidgetGiftCertificate();
	// 		});
	// 	} else {
	// 		this.widgetGiftCertificate = new WidgetGiftCertificate();
	// 	}
	// }

	initLangSwitcher() {
		const langSwitcher = new LangSwitcher();
	}

	initSpecialEvent() {
		if (craft.page.specialEventConfig == null || !craft.page.specialEventConfig.status) return;

		new SpecialEventPopup();
		new SpecialEventQuiz();
	}
}